<template>
  <div>
    <Wp_nav_bar title="礼金活动"></Wp_nav_bar>
    <div>
      <JdGiftInfoCard :gift-data="giftData"/>
    </div>
    <van-list style="min-height: 700px"
              v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="onLoad"
    >
      <van-grid :column-num="2" :border="false">
        <van-grid-item
            v-for="(sku_info, index) in list"
            :key="index"
        >
          <div
              slot="default"
              style="box-shadow: 1px 1px 5px #999999; border-radius: 10px"
          >
            <JdSkuInfoCard
                ref="JdSkuInfoCard"
                :skuInfo="sku_info"
                :gift-data="giftData"
                :img-gray="imgGray"
                :show-simple-button="show_simple_button"
                @showAllButton="showAllButton"
                orientation="vertical"
            >
            </JdSkuInfoCard>
          </div>
        </van-grid-item>
      </van-grid>
    </van-list>
  </div>
</template>
<script>
import JdGiftInfoCard from '../card/JdGiftInfoCard'
import { getSelectGoods } from '../../js/utils'
import JdSkuInfoCard from '../custom/JdSkuInfoCard'
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_card from '../waps_ui/wp_card'

export default {
  components: { Wp_card, Wp_nav_bar, JdSkuInfoCard, JdGiftInfoCard },
  data () {
    return {
      giftCode: null,
      giftData: {},
      skuIdList: [],
      page: 0,
      size: 20,
      list: [],
      total: 0,
      loading: false,
      finished: false,
      show_simple_button: true,
      imgGray: false,
    }
  },
  mounted () {
    let _code = this.$common.getUrlKey('code')
    if (_code) {
      this.giftCode = _code
    } else {
      this.finished = true
    }
  },
  methods: {
    loadGiftSkuList () {
      if (this.giftCode) {
        let data = {
          giftCouponKey: this.giftCode,
          page: this.page,
          size: this.size,
        }
        this.loading = true
        this.$getGiftQuery(data, res => {
          this.loading = false
          if (res.code === 200) {
            if (res.data) {
              this.total = res.data.total
              if (res.data.giftData) {
                this.giftData = res.data.giftData[0]
              }
              if (res.data.list && res.data.list.length > 0) {
                let _list = res.data.list
                for (let i in _list) {
                  let _sku = _list[i]
                  this.list.push(_sku)
                }
              } else {
                this.finished = true
              }
            } else {
              this.finished = true
            }
          }
        })
      }
    },
    showAllButton () {
      this.show_simple_button = false
      this.$common.show_sku_card_simple_button_model = false
    },
    onLoad () {
      this.page = this.page + 1
      if (this.page === 1) {
        this.list = []
      }
      this.loadGiftSkuList()
    }
  }
}
</script>